if (!customElements.get("m-photo-guidance")) {
  customElements.define(
    "m-photo-guidance",
    class MPhotoGuidance extends HTMLElement {
      connectedCallback() {
        // 拿到唯一 ID
        const uid = this.getAttribute("id").replace("photo-guide-", "");
        this.openBtn = this.querySelector(`[data-open-guide="${uid}"]`);
        this.contentNode = document.getElementById(`guide-content-${uid}`);

        if (this.contentNode && this.contentNode.innerHTML) {
          this.content = this.contentNode.innerHTML;
          this.init();
        }
      }

      init() {
        this.modal = new MinimogTheme.Modal();
        this.openBtn?.addEventListener("click", (e) => {
          e.preventDefault();
          if (this.content) {
            const html = document.createElement("DIV");
            html.classList.add("m-photo-guidance__content");
            html.innerHTML = this.content;
            this.modal.appendChild(html);

            const colorScheme = html.querySelector("[data-color-scheme]")?.dataset.colorScheme || "default";
            this.modal.setSizes(`m-photo-guidance m-gradient ${colorScheme}`);
            this.modal.open();
          }
        });
      }
    }
  );
}
